import { type StoreSafeObject, InterProcessEvents } from '@highlight/ipc'

export type GatewayChannelHandler<T extends StoreSafeObject = StoreSafeObject> = (payload: T) => void

class GatewayEventsRouter extends InterProcessEvents {
  constructor() {
    super('gateway.events')
  }

  emitChannel<T extends StoreSafeObject>(channel: string, payload: T) {
    this.emit(this.getChannelEvent(channel), payload)
  }

  onChannel<T extends StoreSafeObject>(channel: string, handler: GatewayChannelHandler<T>) {
    const event = this.getChannelEvent(channel)
    this.on(event, handler as GatewayChannelHandler)
    return () => {
      this.off(event, handler as GatewayChannelHandler)
    }
  }

  private getChannelEvent(channel: string) {
    return `gateway:channel:${channel}`
  }
}

export const GatewayEvents = new GatewayEventsRouter()
